import React from 'react';
import './TwoVideos.css';

const TwoVideos: React.FC = () => {
  return (
    <section className="two-videos">
      <div className="container">

        <div className="video appear delay-1">
          <div className="video-inner">
            <iframe
              src="https://www.youtube.com/embed/RXEt0ZduHdg"
              title="Main Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        <div className="video appear delay-2">
          <div className="video-inner">
            <iframe
              src="https://www.youtube.com/embed/VIR94SKenjs"
              title="Second Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default TwoVideos;
